module.exports = __webpack_public_path__ + "media/img/materialowa@3x-dark-3c3869b0.svg";